<ng-container *ngIf="field.key === 'form'; then formTemplate; else pageTemplate"></ng-container>

<ng-template #formTemplate>
  <dspx-heading [level]="props.headingLevel" [heading]="props.heading"></dspx-heading>
  <dspx-description [text]="props.description"></dspx-description>
  <div *ngFor="let tabs of field.fieldGroup">
    <formly-field [field]="tabs"></formly-field>
  </div>
</ng-template>

<ng-template #pageTemplate>

  <ng-container [ngSwitch]="props.cardSetLayoutOptions?.layoutType || 'plain'">

    <ng-container *ngSwitchCase="'card'">
      <p-card [subheader]="props.description">
        <ng-template pTemplate="header">
          <ng-container *ngTemplateOutlet="layoutTypeHeader"></ng-container>
          <h2 *ngIf="props.heading" class="page-header">{{props.heading}}</h2>
        </ng-template>
        <ng-template pTemplate="content">
          <ng-container *ngTemplateOutlet="layoutTypeContent"></ng-container>
        </ng-template>
      </p-card>
    </ng-container>

    <ng-container *ngSwitchCase="'plain'">
      <ng-container *ngTemplateOutlet="layoutTypeHeader"></ng-container>
      <div class="panel-header">
        <div class="col-8">
          <dspx-heading [level]="props.headingLevel" [heading]="props.heading"></dspx-heading>
        </div>
        <div class="col-4 flex answer-count">
          <div class="item">
            <p><span><strong>{{props.answeredQuestionCount}}/{{props.totalQuestionCount}}</strong></span></p>
          </div>
          <div class="item">
            <p><strong><i class="pi pi-check" style="font-weight: bold"></i></strong></p>
          </div>
        </div>
      </div>
      <dspx-description [text]="props.description"></dspx-description>
      <ng-container *ngTemplateOutlet="layoutTypeContent"></ng-container>
    </ng-container>

    <ng-template #layoutTypeHeader>
      <div class="p-card-header-content">
        <dspx-status-bar *ngIf="props.statusBarContent" [content]="props.statusBarContent"></dspx-status-bar>
      </div>
    </ng-template>

    <ng-template #layoutTypeContent>
      <dspx-validation-summary *ngIf="props.showValidationSummary" [pageField]="field"></dspx-validation-summary>
      <div class="panel-header status-bar">
        <div class="col-sm-4 flex"><span><strong>PIN: </strong>{{props.Pin}}</span></div>
        <div><span><strong>Address: </strong>{{props.Address}}</span></div>
        <div><span><strong>Suburb: </strong>{{props.Suburb}}</span></div>
        <div><span><strong>Inspection Ref: </strong>{{props.Ref}}</span></div>
        <div><span><strong>Version Number: </strong>{{props.Version}}</span></div>
      </div>
      <div class="panel-header grid-header">
        <div class="col-5"><strong>Areas</strong></div>
        <div class="col-4"><strong>Exists on property?</strong></div>
        <div class="col-2 flex grid-header-item"><strong>Progress</strong></div>
        <div class="col-1 flex grid-header-item"><strong>Action</strong></div>
      </div>
      <ng-container *ngIf="!props.hideContent">
        <div class="grid">
          <div [class]="section.props.cardSetLayoutOptions?.gridLayoutStyleClass" *ngFor="let section of field.fieldGroup">

            <ng-container *ngIf="props.isViewMode && props.isViewMode(field); then viewTemplate; else editTemplate"></ng-container>

            <ng-template #viewTemplate>
              <dspx-card-section-view-mode [pageConfig]="field" [sectionConfig]="section"></dspx-card-section-view-mode>
            </ng-template>

            <ng-template #editTemplate>
              <formly-field [field]="section"></formly-field>
            </ng-template>
          </div>
        </div>
      </ng-container>
      <dspx-form-navigation [actionButtons]="props.actionButtons"
                            [requiresBackButton]="props.requiresBackButton"
                            [backButtonLabel]="props.backButtonLabel"
                            [backButtonTitle]="props.backButtonTitle"
                            [requiresNextButton]="props.requiresNextButton"
                            [nextButtonLabel]="props.nextButtonLabel"
                            [nextButtonTitle]="props.nextButtonTitle"
                            [requiresCancelButton]="props.requiresCancelButton"
                            [cancelButtonLabel]="props.cancelButtonLabel"
                            [cancelButtonTitle]="props.cancelButtonTitle"
                            [pageField]="field"
                            [topDividerDisplay]="'never'"
                            [bottomDividerDisplay]="'auto'">
      </dspx-form-navigation>
    </ng-template>

  </ng-container>

</ng-template>
